import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { AddButton, InputBox, TextArea } from "@cpnw/ui";
import DashboardRadio from "components/DashboardRadio";
import styles from "./ImmunizationHepBViewNew.module.css";
import DashboardPassportFileEditorItem from "components/DashboardPassportFileEditorItem";
import { DeclinationEnum } from "pages/enums";
import GenericFileUpload from "./GenericFileUpload";

export const ImmunizationHepBDeclinationForm = ({ value, onChange, disabled }) => {
  const [hepBData, setHepBData] = useState({
    declination: "",
    files: [],
    newFiles: [],
    newFileNames: []
  });
  console.log('value::', value)
  useEffect(() => {
    if (value) {
      setHepBData({
        declination: value.declination || "",
        files: value.files || [],
        newFiles: value.newFiles || [],
        newFileNames: value.newFileNames || [],
      });
    }
  }, [value]);

  const handleDeclinationChange = (selectedValue) => {
    const updated = {
      declination: selectedValue,
      files: [],
      newFiles: [],
    };
    setHepBData(updated);
    onChange?.(updated);
  };

  const handleAddFiles = (files) => {
    const addedNames = files.map(f => f.name);

    const updated = {
      ...hepBData,
      newFiles: [...hepBData.newFiles, ...files],
      newFileNames: [...(hepBData.newFileNames || []), ...addedNames]
    };
    setHepBData(updated);
    onChange?.(updated);
  };

  const handleDeleteFile = (file) => {
    const isExisting = file.Id !== undefined; // existing files have an Id
    const isNew = file.id !== undefined;      // new files use lowercase id

    const updated = {
      ...hepBData,
      files: isExisting
        ? hepBData.files.filter((f) => f.Id !== file.Id)
        : hepBData.files,
      newFiles: isNew
        ? hepBData.newFiles.filter((f) => f.id !== file.id)
        : hepBData.newFiles,
      newFileNames: isNew
        ? hepBData.newFileNames.filter((n) => n !== file.name)
        : hepBData.newFileNames
    };

    setHepBData(updated);
    onChange?.(updated);
  };

  return (
    <div className={styles.container} style={{ marginBottom: '0px' }}>
      <div className={styles.radioRow}>
        <DashboardRadio
          containerClassName={styles.containerClassName}
          isSelected={hepBData.declination === DeclinationEnum.NonConverter}
          onChange={() => handleDeclinationChange(DeclinationEnum.NonConverter)}
          label={DeclinationEnum.NonConverter}
          value={DeclinationEnum.NonConverter}
          name="hepBDeclinationRadio"
          disabled={disabled}
        />

        <DashboardRadio
          containerClassName={styles.containerClassName}
          isSelected={hepBData.declination === DeclinationEnum.SeriesInProcess}
          onChange={() => handleDeclinationChange(DeclinationEnum.SeriesInProcess)}
          label={DeclinationEnum.SeriesInProcess}
          value={DeclinationEnum.SeriesInProcess}
          name="hepBDeclinationRadio"
          disabled={disabled}
        />

        {(hepBData.declination === DeclinationEnum.SeriesInProcess) && (
          <div className={styles.uploadSection}>
            {/* <GenericFileUpload
              label={"Upload Series In Process Form"}
              files={hepBData.files}
              newFiles={hepBData.newFiles}
              onAddFiles={handleAddFiles}
              onDeleteNew={handleDeleteFile}
              onDeleteExisting={handleDeleteFile}
              disabled={disabled}
            /> */}
            <div style={{ margin: '10px 0 10px' }}>
              Upload Series In Process Form Below
            </div>
          </div>
        )}

        <DashboardRadio
          containerClassName={styles.containerClassName}
          isSelected={hepBData.declination === DeclinationEnum.DeclinationForm}
          onChange={() => handleDeclinationChange(DeclinationEnum.DeclinationForm)}
          label={DeclinationEnum.DeclinationForm}
          value={DeclinationEnum.DeclinationForm}
          name="hepBDeclinationRadio"
          disabled={disabled}
        />
      </div>

      {(hepBData.declination === DeclinationEnum.DeclinationForm) && (
        <div className={styles.uploadSection}>
          {/* <GenericFileUpload
            label={"Upload Declination Reason Form"}
            files={hepBData.files}
            newFiles={hepBData.newFiles}
            onAddFiles={handleAddFiles}
            onDeleteNew={handleDeleteFile}
            onDeleteExisting={handleDeleteFile}
            disabled={disabled}
          /> */}
          <div style={{ margin: '10px 0 10px' }}>
            Upload Declination Reason Form Below
          </div>
        </div>
      )}
    </div>
  );
};
